import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ErroNotificacaoService {

  constructor(
    private toasty: ToastrService,
    private rotaNavegar: Router
    ) { }

  handle(errorResponse: any) {
    let msg: string;
    
    if (errorResponse.status >= 400 && errorResponse.status <= 499) {
      if (errorResponse.error) {
        if (errorResponse.error.error === 'invalid_token') {
          msg = 'OCORREU UM PROBLEMA, TOKEN INVÁLIDO!';
        } else if(errorResponse.error.error === 'access_denied'){
          msg = 'VOCÊ NÃO TEM PERMISSÃO!';      
          this.rotaNavegar.navigate(['']);
        } else {
          if(errorResponse.error.length > 0){
            msg = "DUPLICIDADE DO SISTEMA, " + errorResponse.error[0].mensagemUsuario;
          } else {
            console.log(errorResponse);
            msg = 'OCORREU UM ERRO AO PROCESSAR A SUA SOLICITAÇÃO, CONSULTE O ADMINISTRADOR DO SISTEMA';
          }        
        }
      } else {
        console.log(errorResponse);
        msg = 'OCORREU UM ERRO AO PROCESSAR A SUA SOLICITAÇÃO, CONSULTE O ADMINISTRADOR DO SISTEMA';
      }
    } else {
      console.log(errorResponse);
      msg = 'ERRO AO PROCESSAR SERVIÇO REMOTO. CONSULTE O ADMINISTRADOR DO SISTEMA';
    }
    this.toasty.error(msg, 'ATENÇÃO!');
  }
}
